/* istanbul ignore file */

export enum ActionTypeIcon {
    SetField = 'wand_stars',
    StyleFieldColor = 'font_download',
    SetMapPinColor = 'location_on',
    SendEmail = 'mail',
    Dynamic = 'bolt'
}
